/**
 * pages/single.js — single post
 *
 * Enqueued from single.php with:
 *   whytheme_enqueue_script('pages/single');
 *
 * Handles: related-posts Swiper carousel, article gallery Swiper carousel.
 */

import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';

function initRelatedSwiper() {
    const el = document.querySelector('.js-related-swiper');
    if (!el) return;

    new Swiper(el, {
        modules: [Navigation, Pagination],
        slidesPerGroup: 1,
        watchOverflow: true,
        breakpoints: {
            0: { slidesPerView: 1, spaceBetween: 20 },
            768: { slidesPerView: 2, spaceBetween: 19 },
            1024: { slidesPerView: 3, spaceBetween: 19 },
        },
        navigation: {
            prevEl: '.related-prev',
            nextEl: '.related-next',
        },
        pagination: {
            el: '.related-pagination',
            type: 'progressbar',
        },
    });
}

function initGallerySwiper() {
    const el = document.querySelector('.js-gallery-swiper');
    if (!el) return;

    new Swiper(el, {
        modules: [Navigation, Pagination],
        watchOverflow: true,
        breakpoints: {
            0: { slidesPerView: 1.2, spaceBetween: 20 },
            1024: { slidesPerView: 4, spaceBetween: 32 },
        },
        navigation: {
            prevEl: '.gallery-prev',
            nextEl: '.gallery-next',
        },
        pagination: {
            el: '.gallery-pagination',
            type: 'progressbar',
        },
    });
}

function init() {
    initRelatedSwiper();
    initGallerySwiper();
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
} else {
    init();
}
